import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

const { FiShield, FiMenu } = FiIcons;

const Navbar = () => {
  return (
    <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center transition-transform group-hover:rotate-3">
              <SafeIcon icon={FiShield} className="text-2xl text-white" />
            </div>
            <span className="text-2xl font-black tracking-tighter text-slate-900">
              HMS<span className="text-blue-600">INNSIKT</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a href="#tjenester" className="text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors">Tjenester</a>
            <a href="#metodikk" className="text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors">Metodikk</a>
            <Link to="/login" className="text-sm font-semibold text-slate-900 hover:text-blue-600 transition-colors">Logg inn</Link>
            <Link to="/login" className="px-6 py-3 bg-slate-900 text-white text-sm font-bold rounded-xl hover:bg-blue-600 transition-all shadow-lg shadow-slate-200">
              Prøv gratis
            </Link>
          </div>

          <button className="md:hidden p-2 text-slate-600">
            <SafeIcon icon={FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;